import { debounce } from 'lodash';
import { tns } from 'tiny-slider/src/tiny-slider';

class Carousels {
  constructor() {
    // Elements
    this.carouselElements = document.querySelectorAll('[data-carousel]');
    this.cardCarouselElements = document.querySelectorAll(
      '[data-card-carousel]'
    );

    // Controls markup
    this.controlsMarkup = [
      '<i class="fas fa-chevron-left fa-3x"></i><span class="visually-hidden">Prev</span>',
      '<i class="fas fa-chevron-right fa-3x"></i><span class="visually-hidden">Next</span>',
    ];

    // Init
    this.carouselsInit();
    this.cardCarouselsInit();
  }

  cardCarouselsInit() {
    if (this.cardCarouselElements) {
      this.cardCarouselElements.forEach((cardCarouselElement) => {
        // Data attr options
        const options = {
          desktopItems: cardCarouselElement.dataset.carouselDesktopItems || 3,
          tabletItems: cardCarouselElement.dataset.carouselTabletItems || 2,
          mobileItems: cardCarouselElement.dataset.carouselMobileItems || 1,
          desktopEdgePadding:
            cardCarouselElement.dataset.carouselDesktopEdgePadding || 0,
          tabletEdgePadding:
            cardCarouselElement.dataset.carouselTabletEdgePadding || 0,
          mobileEdgePadding:
            cardCarouselElement.dataset.carouselMobileEdgePadding || 0,
        };
        const instance = tns({
          mode: 'carousel',
          container: cardCarouselElement,
          nav: true,
          navPosition: 'bottom',
          controls: false,
          controlsText: this.controlsMarkup,
          autoplay: false,
          autoplayHoverPause: true,
          autoplayButtonOutput: false,
          loop: true,
          items: options.mobileItems,
          edgePadding: options.mobileEdgePadding,
          gutter: 12,
          mouseDrag: true,
          center: true,
          responsive: {
            576: {
              edgePadding: options.tabletEdgePadding,
              items: options.tabletItems,
            },
            992: {
              edgePadding: options.desktopEdgePadding,
            },
            768: {
              items: options.desktopItems,
              controls: true,
              gutter: 20,
            },
          },
        });
        window.addEventListener(
          'resize',
          debounce(() => {
            instance.refresh();
          }, 500)
        );
      });
    }
  }

  carouselsInit() {
    if (this.carouselElements) {
      this.carouselElements.forEach((carouselElement) => {
        // Data attr options
        const options = {
          hideMobileControls: !carouselElement.hasAttribute(
            'data-carousel-hide-mobile-controls'
          ),
          autoPlay: carouselElement.hasAttribute('data-carousel-autoplay'),
          autoHeight: carouselElement.hasAttribute('data-carousel-autoheight'),
        };

        tns({
          container: carouselElement,
          mode: 'carousel',
          autoplay: options.autoPlay,
          controls: options.hideMobileControls,
          autoHeight: options.autoHeight,
          speed: 500,
          center: true,
          gutter: 16,
          items: 1,
          loop: true,
          edgePadding: 0,
          autoplayHoverPause: true,
          autoplayButtonOutput: false,
          mouseDrag: true,
          controlsText: [
            '<i class="fas fa-chevron-left fa-2x"></i><span class="visually-hidden">Prev</span>',
            '<i class="fas fa-chevron-right fa-2x"></i><span class="visually-hidden">Next</span>',
          ],
          onInit: () => {
            if (carouselElement.querySelector('.image__caption')) {
              // Position the nav from the top of the carousels picture element so we can place caption below each slide, element must have a caption
              this.positionNavInit(carouselElement);

              // Position the prev/next controls 50% image height if captions are present
              this.positionControlsInit(carouselElement);
            }
          },
          responsive: {
            576: {
              edgePadding: 40,
            },
            768: {
              edgePadding: 80,
            },
            1400: {
              controls: true,
            },
          },
        });
      });
    }
  }

  positionNavInit(carousel) {
    this.positionNav(carousel);
    window.addEventListener(
      'resize',
      debounce(() => {
        this.positionNav(carousel);
      }, 100)
    );
  }

  positionNav(carousel) {
    const image = carousel.querySelector('picture');
    const nav = carousel
      .closest('.carousel__wrapper')
      .querySelector('.tns-nav');
    const offset = image.offsetHeight - nav.offsetHeight - 24;
    nav.style.top = `${offset}px`;
    nav.style.bottom = 'auto';
  }

  positionControlsInit(carousel) {
    this.positionControls(carousel);
    window.addEventListener(
      'resize',
      debounce(() => {
        this.positionControls(carousel);
      }, 100)
    );
  }

  positionControls(carousel) {
    const image = carousel.querySelector('picture');
    const controls = carousel
      .closest('.carousel__wrapper')
      .querySelector('.tns-controls');
    const offset = image.offsetHeight / 2;
    controls.style.top = `${offset}px`;
  }
}

document.addEventListener('DOMContentLoaded', () => new Carousels());
